<template>
  <div class="d-flex">
    <icon class="my-auto" :icon="['fad', 'timer']"/>&nbsp;<span class="my-auto" id="timer"
                                                                v-bind:class="[startIntervall === null ? '' : 'h1']"></span>&nbsp;
    <button v-on:click="startInitialCountdown()" class="btn" v-if="startIntervall === null && intervall === null">
      <icon :icon="['fad', 'play']" class="text-warning"/>
      Start
    </button>
    <button v-on:click="pause()" class="btn" v-if="intervall !== null && hasPause === false">
      <icon :icon="['fad', 'pause']" class="text-warning"/>
    </button>
    <button v-on:click="resume()" class="btn" v-if="intervall !== null && hasPause === true">
      <icon :icon="['fad', 'play']" class="text-warning"/>
      Resume
    </button>
    <button v-on:click="reset()" class="btn" v-if="intervall !== null && hasPause === true">
      <icon :icon="['fad', 'rotate-left']" class="text-warning"/>
      Reset
    </button>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {start} from "@popperjs/core";
import {Modal} from "bootstrap";

export default {
  name: "Timer",
  components: {},
  props: [
    'presentationTime',
  ],
  data() {
    return {
      countDown: this.presentationTime,
      startCountdown: 5,
      intervall: null,
      startIntervall: null,
      hasPause: false
    }
  },
  created() {
    // this.startInitialCountdown();
  },
  mounted() {
    this.reset();
  },
  beforeDestroy() {
    window.clearInterval(this.intervall);
  },
  methods: {
    ...mapActions([]),
    stop() {
      window.clearInterval(this.intervall);
    },
    pause() {
      this.hasPause = true;
      window.clearInterval(this.intervall);
    },
    resume() {
      this.hasPause = false;
      this.start();
    },
    startInitialCountdown() {
      if (this.startIntervall !== null) {
        this.stop();
      }
      const timerElement = window.document.getElementById('timer');
      timerElement.textContent = "05";
      this.startIntervall = window.setInterval(() => {
        if (this.startCountdown === 0) {
          window.clearInterval(this.startIntervall);
          this.start();
        }
        this.startCountdown--;
        this.updateStartTimer();
      }, 1000)
    },
    start() {
      if (this.intervall !== null) {
        this.stop();
      }
      this.updateTimer();
      this.intervall = window.setInterval(() => {
        if (this.countDown === 0) {
          this.stop();
        }
        this.countDown--;
        this.updateTimer();
      }, 1000)
    },
    reset() {
      this.stop();
      this.hasPause = false;
      const timerElement = window.document.getElementById('timer');
      timerElement.textContent = "";
      this.countDown = this.presentationTime;
      this.startCountdown = 5;
      this.intervall = null;
      this.startIntervall = null;
    },
    updateStartTimer() {
      const timerElement = window.document.getElementById('timer');
      if (this.startCountdown <= 0) {
        timerElement.textContent = "00";
        window.clearInterval(this.startIntervall);
        this.startIntervall = null;
        this.start();
        return;
      }
      const seconds = String(this.startCountdown % 60).padStart(2, '0');
      timerElement.textContent = `${seconds}`;
    },
    updateTimer() {
      const timerElement = window.document.getElementById('timer');
      if (this.countDown <= 0) {
        timerElement.textContent = "00:00"; // Countdown beendet
        window.clearInterval(this.intervall); // stoppt den Countdown
        this.reset();
        this.openModal();
        return;
      }
      const minutes = String(Math.floor((this.countDown % 3600) / 60)).padStart(2, '0');
      const seconds = String(this.countDown % 60).padStart(2, '0');
      timerElement.textContent = `${minutes}:${seconds}`;
    },
    openModal() {
      let modal = new Modal(document.getElementById('staticBackdropTimeout'));
      modal.show();
    }
  },
  computed: {}
}
</script>

<style type="text/css" scoped>
</style>
